import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject, input } from '@angular/core';
import { SbPremiumService } from './sb-premium.service';

/**
 * Shows a paid feature's controls to an account without it, inert: they stay visible, cannot be
 * reached by mouse or keyboard, and a click on them opens the premium popup instead.
 */
@Component({
  selector: 'app-sb-premium-lock',
  template: `
    <div class="sb-premium-lock" [class.sb-premium-lock--locked]="locked()">
      <div class="sb-premium-lock__content" [attr.inert]="locked() ? '' : null">
        <ng-content></ng-content>
      </div>
      @if (locked()) {
      <button type="button" class="sb-premium-lock__overlay"
              [attr.aria-label]="feature() + ' is a paid feature'"
              (click)="premium.explain(feature())"></button>
      }
    </div>
  `,
  styleUrls: ['./sb-premium.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SbPremiumLockComponent {
  protected readonly premium = inject(SbPremiumService);

  readonly locked = input(false);
  /** The feature's name, as the popup names it. */
  readonly feature = input.required<string>();
}
